// @flow

export const ESTIMATE_ACCORDION_KEYS = {
  ESTIMATE_DETAILS: 'estimate-details',
  PREVIOUS_CONTRACT_DETAILS: 'previous-contract-details',
  CUSTOM_DISCOUNTS: 'custom-discounts',
  COMMITTED_CAPACITY: 'committed-capacity',
  CREDITS_AND_BURSTS: 'credits-and-bursts',
  ADVANCED_SECURITY_CUSTOM_DISCOUNTS: 'advanced-security-custom-discounts',
  CLUSTERS_SUMMARY: 'clusters-summary',
  FLINK_SUMMARY: 'flink-summary',
  NATIVE_INFERENCE_SUMMARY: 'native-inference-summary',
  STREAM_GOVERNANCE_SUMMARY: 'stream-governance-summary',
  TCO_INPUTS: 'tco-inputs',
  ESTIMATE_SUMMARY: 'estimate-summary',
};
